import React, { useEffect, useState, useContext } from 'react';
import StyledTable from './StyledTable';
import { UserContext } from '../UserContext';
import { Box, TextField, Button, Typography } from '@mui/material';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import LabeledTextField from "./LabeledTextField";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import "./AdminPage.css"

import "react-toastify/dist/ReactToastify.css";


const API_URL = '/api/roles/';

export default function AdminPage() {
    const [roles, setRoles] = useState([]);
    const [name, setName] = useState('');
    const [editId, setEditId] = useState(null);
    const [currentDate, setCurrentDate] = useState(getFormattedDate());
    const { user_id, role } = useContext(UserContext);
    const navigate = useNavigate();


    console.log(role, "valueeee");

    const fetchRoles = async () => {
        try {
            const res = await fetch(API_URL);
            const data = await res.json();
            setRoles(data);
        } catch (error) {
            console.error('Error fetching roles:', error);
            toast.error('Error fetching roles:', error);

        }
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editId) {
                await fetch(`${API_URL}${editId}/`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ name }),
                });
                setEditId(null);
                toast.success('Role updated successfully!');
            } else {
                await fetch(API_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ name }),
                });
                toast.success('Role created successfully!');
            }
            setName('');
            fetchRoles();
        } catch (error) {
            console.error('Error submitting role:', error);
            toast.error('Error submitting role.');
        }
    };


    const handleEdit = (role) => {
        navigate(`/adminsetting/${role.id}`);
    };

    const handleDelete = async (id) => {
        try {
            const res = await fetch(`${API_URL}${id}/`, { method: 'DELETE' });
            if (res.status === 404) {
                toast.error('Role not found or already deleted.');
            } else {
                toast.success('Role deleted successfully!');
            }
            fetchRoles();
        } catch (error) {
            toast.error('Error deleting role.');
            console.error('Error deleting role:', error);
        }
    };




    const columns = [
        { field: 'id', headerName: 'ID', align: 'center' },
        { field: 'name', headerName: 'Role Name', align: 'center' },
        { field: "employee_count", headerName: "Employee_count", align: "center" },
        { field: 'actions', headerName: 'Actions', align: 'center' },
    ];


    function getFormattedDate() {
        const now = new Date();
        const day = now.toLocaleString("en-US", { weekday: "short" });
        const month = now.toLocaleString("en-US", { month: "short" });
        const date = now.toLocaleString("en-US", { day: "2-digit" });
        const year = now.getFullYear();
        const time = now.toLocaleString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
        return `${day}, ${month} ${date}, ${year} ${time}`;
    }

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentDate(getFormattedDate());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <Box className="admin-container">
            <ToastContainer />
            <div className="admin-header">
                <Box className="admin-head">
                    <AdminPanelSettingsOutlinedIcon className="admin-icon" />
                    <span className="title">AdminPage</span>
                </Box>
                <span className="title date">{currentDate}</span>
            </div>
            <form onSubmit={handleSubmit} className="admin-form">
                <Box className="form-container">
                    <LabeledTextField
                        placeholder="Role Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        fullWidth
                        size="small"
                        className="role-input"
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        className="submit-button"
                    >
                        {editId ? 'Update' : 'Add'}
                    </Button>
                    {editId && (
                        <Button
                            type="button"
                            variant="outlined"
                            onClick={() => {
                                setEditId(null);
                                setName('');
                            }}
                            className="cancel-button"
                        >
                            Cancel
                        </Button>
                    )}
                </Box>
            </form>
            <StyledTable
                columns={columns}
                data={roles}
                onEdit={handleEdit}
                onDelete={handleDelete}
                disableDelete={(row) => row.name === "Super Admin" || row.name === "Employee"}
                itemsPerPage={4}
            />
        </Box>
    );
}